import { useTheme } from '../context/ThemeContext';

/**
 * The "dft" monogram, traced as strokes from the brand artwork
 * (dft_bold15_2048.png, 2048px square; matches it to within the antialiased
 * edges). The viewBox is cropped to the mark itself.
 *
 * White on the dark theme, black on the light theme. Sized in em, so it
 * scales with the font size of the wordmark it sits next to.
 */
export default function DftMark({ height = '1em', style }) {
  const { theme } = useTheme();
  return (
    <svg
      viewBox="344.5 622 1392.5 729"
      style={{ height, width: 'auto', flexShrink: 0, display: 'block', ...style }}
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke={theme === 'dark' ? '#ffffff' : '#000000'} strokeWidth="100">
        {/* d */}
        <path d="M713 883H510.5A116 116 0 0 0 394.5 999V1183.5A116 116 0 0 0 510.5 1299.5H697A116 116 0 0 0 813 1183.5V622" />
        {/* f */}
        <path d="M941 1351V788A116 116 0 0 1 1057 672H1313" />
        {/* t */}
        <path d="M1468 622V1351M1038 877H1737" />
      </g>
    </svg>
  );
}
